import { ajax } from '@/plugins/ajax';

export default {
    namespaced: true,
    state: {
    },
    getters: {
    },
    actions: {
        fetchProducts({ commit }, id) {
            return new Promise((resolve, reject) => {
                ajax.get('Sales/api/ProductQuery/configurable/items/'+id)     
                    .then((r) => {
                        resolve(r);
                    })
                    .catch((e) => reject(e));
            });
        }
    },
    mutations: {
    }
};
